<template>
  <div class="student-high-care">
    <v-simple-table class=" table-layout table-fixed student-care-table" id="style-2" fixed-header>
        <template v-slot:default>
    <!-- <table class="student-care-table"> -->
        <thead>
        <tr>
          <th rowspan="2" class="scroll-left" style="min-width:160px;max-width:160px;left:0px">Mã Khách hàng</th>
          <th rowspan="2" class="scroll-left" style="min-width:160px;max-width:160px;left:160px">Tên học viên</th>
          <th rowspan="2" class="scroll-left" style="min-width:160px;max-width:160px;left:320px">Chương trình</th>
          <th rowspan="2" class="scroll-left text-center" style="min-width:160px;max-width:160px;left:480px">Ngày vào danh sách</th>
          <th v-if="$route.query.schoolLevel === 'secondary'" rowspan="2" class="scroll-left" style="min-width:18px;max-width:180px;left:640px; color: #B00;">Hạn chăm sóc bắt buộc</th>
          <th colspan="2" class="border-x text-center" style="border-right: none;">Chuyên cần</th>
          <th colspan="2" class="border-x text-center">Học tập</th>
          <th rowspan="2">Huỷ buổi
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span class="my-auto ml-2" v-on="on" v-bind="attrs">
                    <img src="../../../assets/info-icon.svg" alt="">
                </span>
              </template>
              Vi phạm của học sinh được tính trong tối đa 8 buổi học gần nhất
            </v-tooltip>
          </th>
          <th rowspan="2">Đổi giáo viên
             <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span class="my-auto ml-2" v-on="on" v-bind="attrs">
                    <img src="../../../assets/info-icon.svg" alt="">
                </span>
              </template>
              Vi phạm của học sinh được tính trong tối đa 8 buổi học gần nhất
            </v-tooltip>
          </th>
          <th rowspan="2">Bài kiểm tra sắp tới</th>
          <th rowspan="2">Quản lý lớp</th>
          <th rowspan="2">Trạng thái CSĐK</th>
          <th rowspan="2">Lịch sử chăm sóc</th>
        </tr>
        <tr>
          <th style="min-width: 140px;border-right: none;" class="border-x border-t">Nghỉ không phép
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span class="my-auto ml-2" v-on="on" v-bind="attrs">
                    <img src="../../../assets/info-icon.svg" alt="">
                </span>
              </template>
              Vi phạm của học sinh được tính trong tối đa 8 buổi học gần nhất
            </v-tooltip>
          </th>
          <th style="min-width: 140px;border-right: none;" class="border-x border-t">Đi muộn về sớm
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span class="my-auto ml-2" v-on="on" v-bind="attrs">
                    <img src="../../../assets/info-icon.svg" alt="">
                </span>
              </template>
              Vi phạm của học sinh được tính trong tối đa 8 buổi học gần nhất
            </v-tooltip>
          </th>
          <th style="min-width: 140px;border-right: none;" class="border-x border-t">Không làm bài tập
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span class="my-auto ml-2" v-on="on" v-bind="attrs">
                    <img src="../../../assets/info-icon.svg" alt="">
                </span>
              </template>
              Vi phạm của học sinh được tính trong tối đa 8 buổi học gần nhất
            </v-tooltip>
          </th>
          <th style="min-width: 140px;" class="border-x border-t">Kiểm tra (unit test/final test)
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span class="my-auto ml-2" v-on="on" v-bind="attrs">
                    <img src="../../../assets/info-icon.svg" alt="">
                </span>
              </template>
              Điểm kiểm tra dưới 5/ giảm 2 điểm so với bài kiểm tra gần nhất
            </v-tooltip>
          </th>
        </tr>
      </thead>
        <transition name="fade" mode="out-in">
          <template v-if="dataBlendedTutor || otherDataBlendedTutor">
            <tbody key="first-tbody" v-if="dataBlendedTutor.length">
            <tr
              v-for="(item, index) in dataBlendedTutor"
              :key="'student_care' + index"
              :class="checkIsOverCareDate(item.date_care) ? 'over-care-date' : ''"
            >
              <td class="scroll-left" style="min-width:160px;max-width:160px;left:0px">
                <div v-if="item.contact_code" class="d-flex align-center">
                  <img
                    src="../../../assets/star-icon.svg"
                    class="mr-2"
                    height="16"
                    width="16"
                    alt=""
                    :style="`visibility: ${
                    item.is_new_call ? 'visible' : 'hidden'
                  }`"
                  />
                  <span>{{ item.contact_code }}</span>
                  <div @click.stop="">
                    <v-tooltip right>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          size="small"
                          rounder
                          icon
                          v-on="on"
                          @click="copyContactId(item)"
                        >
                          <img src="../../../assets/copy-icon.svg" alt="">
                        </v-btn>
                      </template>
                      <span>Copy</span>
                    </v-tooltip>
                  </div>
                </div>
                <span v-else>--</span>
              </td>
              <td class="scroll-left" style="min-width:160px;max-width:160px;left:160px">
                <div class="d-flex justify-space-between">
                  <div
                    class="mr-3 text-left"
                    style="font-weight: bold; cursor: pointer"
                    @click="showQuickView(item)"
                  >
                    {{ item.full_name }}
                  </div>
                  <div class="d-flex mt-2">
                    <v-menu offset-y v-if="item.phoneRelated && item.phoneRelated.length">
                      <template v-slot:activator="{ on: menu, attrs }">
                        <div
                          class="d-flex flex-column align-center"
                          v-bind="attrs"
                          v-on="menu"
                        >
                          <img src="../../../assets/phone-icon.svg" height="20" width="20" alt="">
                        </div>
                      </template>
                      <v-list>
                        <v-list-item
                          @click="handleExecuteCall(item, item.mobile)"
                          class="main-mobile"
                        >
                          <v-list-item-title>{{formatNormalStylePhone(item.mobile)}}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-for="(phone, index) in item.phoneRelated"
                          :key="index"
                          @click="handleExecuteCall(item, phone)"
                          class="sub-mobile"
                        >
                          <v-list-item-title>{{formatNormalStylePhone(phone)}}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <div
                      v-else
                      style="cursor: pointer"
                      @click.stop="handleExecuteCall(item, item.mobile)"
                    >
                      <img src="../../../assets/phone-icon.svg" height="20" width="20" alt="">
                    </div>
                    <!-- <v-menu offset-y>
                      <template v-slot:activator="{ on: menu, attrs }">
                          <div
                            class="d-flex flex-column align-center"
                            v-bind="attrs"
                            v-on="menu"
                            @click="checkPhoneRelated(item)"
                          >
                            <img src="../../../assets/phone-icon.svg" height="20" width="20" alt="">
                          </div>
                      </template>
                      <v-list>
                        <v-list-item
                          @click="handleExecuteCall(item, item.mobile)"
                          class="main-mobile"
                        >
                          <v-list-item-title>{{formatNormalStylePhone(item.mobile)}}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-for="(phone, index) in contactPhoneRelated"
                          :key="index"
                          @click="handleExecuteCall(item, phone)"
                          class="sub-mobile"
                        >
                          <v-list-item-title>{{formatNormalStylePhone(phone)}}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu> -->
                    <v-tooltip right>
                      <template v-slot:activator="{ on,attrs }">
                        <div
                          v-if="checkSchoolLevelPermission('create-task-blended_create', 'create-task-blended-secondary_create')"
                          v-on="on"
                          v-bind="attrs"
                        >
                          <img src="../../../assets/createtask.svg" style="cursor: pointer" class="ml-4" alt="" srcset=""  @click="createTask(item)">
                        </div>
                      </template>
                      <div>Tạo công việc</div>
                    </v-tooltip>
                  </div>
                </div>
              </td>
              <td class="scroll-left text-left" style="min-width:160px;max-width:160px;left:320px">
                <v-tooltip top v-if="mapProgramIdAndProgram[item.curriculum_id]">
                  <template v-slot:activator="{ on, attrs }">
                    <div v-on="on" v-bind="attrs">
                      {{ handleCutString(mapProgramIdAndProgram[item.curriculum_id].title) }}
                    </div>
                  </template>
                  <div>{{ mapProgramIdAndProgram[item.curriculum_id].title }}</div>
                </v-tooltip>
                <div v-else>--</div>
              </td>
              <td class="scroll-left text-center" style="min-width:160px;max-width:160px;left:480px">{{ formatDate(item.date_join_list) }}</td>
              <td v-if="$route.query.schoolLevel === 'secondary'" class="scroll-left" style="min-width:160px;max-width:160px;left:640px; color: #B00;"><div class="d-flex justify-center">{{ formatDate(item.date_care) }}
                <div class="mx-2" v-if="checkIsOverCareDate(item.date_care)" >
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <div v-on="on" v-bind="attrs">
                        <img src="../../../assets/danger.svg" alt="">
                      </div>
                    </template>
                    Quá hạn bắt buộc
                  </v-tooltip>
                </div>
              </div>
              </td>
              <td class="text-left">
                <div v-if="item.no_adtention" class="d-flex justify-space-between">
                  <div>
                    <div v-if="item.no_adtention.lessons">{{ item.no_adtention.lessons }} buổi</div>
                    <div  v-if="item.no_adtention.lessons" class="d-flex justify-space-between">
                    <span v-if="item.no_adtention.lienTiep" class="text-no-wrap mr-1"
                    >Liên tiếp: {{ item.no_adtention.lienTiep }} buổi</span
                    >
                    </div>
                  </div>
                  <div class="d-flex" v-if="item.no_adtention.details && item.no_adtention.details.length > 0">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <div class="my-auto" v-on="on" v-bind="attrs">
                          <img src="../../../assets/info-icon.svg" alt="">
                        </div>
                      </template>
                      <div
                        v-for="(tem, index) in item.no_adtention.details"
                        :key="'NKP' + index"
                      >
                        <svg v-if="tem.isLienTiep" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                          <circle cx="3.5" cy="3.5" r="3.5" fill="#EB5757"/>
                        </svg>
                        <span v-else style="margin-left: 10px"></span>
                        {{ index + 1 }}. {{ tem.text }}
                      </div>
                    </v-tooltip>
                  </div>
                </div>
              </td>
              <td class="text-left">
                <div v-if="item.late" class="d-flex justify-space-between">
                  <div>
                    <div v-if="item.late.lessons">{{item.late.lessons }} buổi</div>
                    <div v-if="item.late.lessons" class="d-flex justify-space-between">
                      <span v-if="item.late.lienTiep" class="text-no-wrap mr-1"
                      >Liên tiếp: {{ item.late.lienTiep }} buổi</span
                      >
                    </div>
                  </div>
                  <div v-if="item.late.details && item.late.details.length > 0" class="d-flex">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <div class="my-auto" v-on="on" v-bind="attrs">
                          <img src="../../../assets/info-icon.svg" alt="">
                        </div>
                      </template>
                      <div
                        v-for="(tem, index) in item.late.details"
                        :key="'NKP' + index"
                      >
                        <div>
                          <svg v-if="tem.isLienTiep" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                            <circle cx="3.5" cy="3.5" r="3.5" fill="#EB5757"/>
                          </svg>
                          <span v-else style="margin-left: 10px"></span>
                          {{ index + 1 }}. {{ tem.text }}
                        </div>
                      </div>
                    </v-tooltip>
                  </div>
                </div>
              </td>
              <td class="text-left">
                <div v-if="item.no_homework" class="d-flex justify-space-between">
                  <div>
                    <div v-if="item.no_homework.lessons"  class="text-no-wrap">{{ item.no_homework.lessons }} bài</div>
                    <div v-if="item.no_homework.lessons"  class="d-flex justify-space-between">
                    <span v-if="item.no_homework.lienTiep" class="text-no-wrap mr-1"
                    >Liên tiếp: {{ item.no_homework.lienTiep }} bài</span
                    >
                    </div>
                  </div>
                  <div v-if="item.no_homework.details && item.no_homework.details.length > 0" class="d-flex">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <div class="my-auto" v-on="on" v-bind="attrs">
                          <img src="../../../assets/info-icon.svg" alt="">
                        </div>
                      </template>
                      <div
                        v-for="(tem, index) in item.no_homework.details"
                        :key="'NKP' + index"
                      >
                        <div>
                          <svg v-if="tem.isLienTiep" xmlns="http://www.w3.org/2000/svg" width="7" height="7" viewBox="0 0 7 7" fill="none">
                            <circle cx="3.5" cy="3.5" r="3.5" fill="#EB5757"/>
                          </svg>
                          <span v-else style="margin-left: 10px"></span>
                          {{ index + 1 }}. {{ tem.text }}
                        </div>
                        <div class="child-content">{{tem.childText}}</div>
                      </div>
                    </v-tooltip>
                  </div>
                </div>
              </td>
              <td class="text-center">
                <div class="d-flex justify-space-between" v-for="tem in item.test" :key="tem.lessonId">
                  <div class="mx-1 d-flex">{{formatDate(tem.date_test)}}: {{tem.score}} điểm
                    <up-down-scope
                      v-if="tem.compareAveragePoint && ['increase','decrease'].includes(tem.compareAveragePoint) && tem.comparePointAveragePoint"
                      :percent="false"
                      :value="tem.comparePointAveragePoint"
                      :kind="tem.compareAveragePoint"
                      color="red"
                    ></up-down-scope>
                  </div>
                  <img v-if="tem.link" src="../../../assets/external-link-icon.svg" alt="" style="cursor: pointer;" @click="openLink(tem.link)">
                </div>
              </td>
              <td class="text-left">
                <div v-if="item.cancel_lesson && item.cancel_lesson.data"  class="d-flex">
                  <div class="text-no-wrap m-auto">{{item.cancel_lesson.lessons}} buổi</div>
                  <div class="mx-1 m-auto" v-if="item.cancel_lesson.data.length">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <div v-on="on" v-bind="attrs">
                          <img class="mt-1" v-if="item.cancel_lesson.isRevertCancel" src="../../../assets/danger.svg" alt="">
                          <img class="mt-1" v-else src="../../../assets/info-icon.svg" alt="">
                        </div>
                      </template>
                      <div
                        v-for="(tem, index) in item.cancel_lesson.data"
                        :key="'NKP' + index"
                      >
                        <div class="d-flex justify-space-between">
                          <div>{{ index + 1 }}. {{ tem.text }}</div> <img v-if="tem.isRevertCancel" src="../../../assets/danger.svg" alt="">
                        </div>
                      </div>
                    </v-tooltip>
                  </div>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        size="small"
                        rounder
                        icon
                        v-on="on"
                        class="my-auto"
                        @click="redirectDetail(item)"
                      >
                        <img src="../../../assets/external-link-icon.svg" alt="">
                      </v-btn>
                    </template>
                    Mở xem chi tiết
                  </v-tooltip>
                </div>
              </td>
              <td>
                <div v-if="item.change_teacher && item.change_teacher.data && item.change_teacher.data.length"  class="d-flex">
                  <div class="text-no-wrap m-auto">{{item.change_teacher.data.length}} buổi</div>
                  <div class="mx-1 m-auto" v-if="item.change_teacher.data.length">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <div v-on="on" v-bind="attrs">
                          <img class="mt-1" v-if="item.change_teacher.isDelete" src="../../../assets/danger.svg" alt="">
                          <img class="mt-1" v-else src="../../../assets/info-icon.svg" alt="">
                        </div>
                      </template>
                      <div
                        v-for="(tem, index) in item.change_teacher.data"
                        :key="'NKP' + index"
                      >
                        <div class="d-flex justify-space-between">
                          <div>{{ index + 1 }}. {{ tem.text }}</div> <img v-if="tem.isDelete" src="../../../assets/danger.svg" alt="">
                        </div>
                      </div>
                    </v-tooltip>
                  </div>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        size="small"
                        rounder
                        icon
                        v-on="on"
                        class="my-auto"
                        @click="redirectDetail(item)"
                      >
                        <img src="../../../assets/external-link-icon.svg" alt="">
                      </v-btn>
                    </template>
                    Mở xem chi tiết
                  </v-tooltip>
                </div>
              </td>
              <td>
                <div>{{ formatDate(item.date_next_test) }}</div>
              </td>
              <td class="text-left">
                <div class="text-no-wrap">{{ item.homeroom_teacher_name }}</div>
              </td>
              <td
                :style="`color: ${mapCallStatusBlendedTutor && mapCallStatusBlendedTutor[item.call_status_id] ? mapCallStatusBlendedTutor[item.call_status_id].color : ''}`" class="text-no-wrap text-left">
                {{
                  mapCallStatusBlendedTutor && mapCallStatusBlendedTutor[item.call_status_id] ? `${changePrefix(mapCallStatusBlendedTutor[item.call_status_id].callType)}-${mapCallStatusBlendedTutor[item.call_status_id].callStatus}` : ''
                }}
              </td>
              <td>
                <div style="display: flex" v-if="item.routine_history_json">
                  <div
                    class="list-status-history"
                    v-for="status in JSON.parse(item.routine_history_json).slice(-5)"
                    :key="status.id"
                    :style="generateCss(mapCallStatusBlendedTutor && mapCallStatusBlendedTutor[status.call_status_id] ? mapCallStatusBlendedTutor[status.call_status_id].color : '')"
                  >
                    {{
                      mapCallStatusBlendedTutor && mapCallStatusBlendedTutor[status.call_status_id] ? changePrefix(mapCallStatusBlendedTutor[status.call_status_id].callType) : ''
                    }}
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
            <tbody key="second-tbody" v-else-if="otherDataBlendedTutor.length > 0">
            <tr v-for="(item, index) in otherDataBlendedTutor" :key="'otherdata' + index">
              <td colspan="99" style="text-align: left">
                {{item.text}}
              </td>
            </tr>
            </tbody>
            <tbody key="third-tbody" v-else>
            <tr>
              <td colspan="15" class="text-center">
                <div class="w-100 d-flex justify-center align-center flex-column" style="margin: 32px 0px">
                  <img src="../../../../student_detail_bt/assets/close-icon.png" alt="" class="mb-2">
                  <img src="../../../../student_detail_bt/assets/no-data-exercise.png" alt="" class="mb-5">
                  <span style="color: #828282">
                Không có dữ liệu
              </span>
                </div>
              </td>
            </tr>
            </tbody>
          </template>
          <tbody key="fourth-tbody" v-else>
          <tr v-for="n in 6" :key="'skeleton-loading-'+n">
            <td colspan="99">
              <v-skeleton-loader type="table-row"></v-skeleton-loader>
            </td>
          </tr>
          </tbody>
        </transition>
      </template>
    </v-simple-table>
    <!-- </table> -->
  </div>
</template>

<script>
import * as moment from 'moment';
import { mapGetters, mapState, mapActions } from 'vuex';
import TokenService from '@/helpers/token';
import UpDownScope from '@/modules/student_detail_bt/components/ModalScoreDetail/UpDownScope.vue';
import BlendedCareRepository from '@/services/BlendedCareRepository';
import { TYPE_CURRICULUM_OBJ } from '@/helpers/constant';

export default {
  components: { UpDownScope },
  data() {
    return {
      contactPhoneRelated: [],
    };
  },
  computed: {
    ...mapGetters('blended', ['mapCallStatusBlendedTutor']),
    ...mapState('blended', ['dataBlendedTutor', 'loading', 'otherDataBlendedTutor']),
    ...mapGetters('student_care', ['mapProgramIdAndProgram']),
  },
  methods: {
    ...mapActions('student_care', ['getCareContactDetail']),
    copyContactId(item) {
      navigator.clipboard.writeText(item.contact_code ? item.contact_code : item.contact_id).then(
        () => {
          this.$swal({
            type: 'success',
            icon: 'success',
            showConfirmButton: false,
            toast: true,
            timer: 1000,
            title: 'Sao chép thành công!',
            position: 'top',
          });
        },
      );
    },
    async showQuickView(item) {
      const routeData = this.$router.resolve({ name: 'StudentDetailBlended', params: { id: item.id }, query: { typeCurriculum: TYPE_CURRICULUM_OBJ.ONLINE, taskType: 1, schoolLevel: this.$route.query.schoolLevel } });
      window.open(routeData.href, '_blank');
      if (item.is_new_call) {
        const response = await this.markAsReadUser(item);
        if (response.message === 'Success') {
          // eslint-disable-next-line no-param-reassign
          item.is_new_call = 0;
        }
      }
    },
    async handleExecuteCall(dataContact, phone) {
      const user = TokenService.getUser();
      if (user.ext) {
        const data = {
          mobile: phone,
          showCreateAppointment: false,
          contactId: dataContact.contact_id,
          callcenter_id: user.callCenterId,
          mainId: dataContact.mainId,
          mainMobile: phone,
          store: 'T',
          contactCode: dataContact.contact_code,
          homeroomTeacherId: dataContact.homeroom_teacher_id,
          studentProductId: dataContact.student_product_id,
          callStatusId: dataContact.call_status_id,
          callId: dataContact.call_id,
          module: 'blended',
        };
        Bus.$emit('voice-call-show-popup', data);
        if (dataContact.is_new_call) {
          const response = await this.markAsReadUser(dataContact);
          if (response.message === 'Success') {
            // eslint-disable-next-line no-param-reassign
            dataContact.is_new_call = 0;
          }
        }
      } else {
        this.$swal({
          title: 'Lỗi!',
          text: 'Chưa có máy lẻ. Vui lòng liên hệ Admin.',
        });
      }
    },
    handleCutString(str) {
      if (str.length > 15) {
        return `${str.slice(0, 15)}...`;
      }
      return str;
    },
    formatDate(date) {
      if (date) {
        return moment(date).format('DD/MM/YYYY');
      }
      return '';
    },
    generateCss(hex) {
      if (!hex) return '';
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex.substring(0, 7));
      return result ? `background: rgba(${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}, 0.15); border: 1px solid ${hex}; color: ${hex}` : '';
    },
    changePrefix(text) {
      return text ? text.replace('TA', 'BT') : text;
    },
    checkIsOverCareDate(date) {
      const today = moment().format('YYYY-MM-DD');
      return moment(date).isBefore(today);
    },
    openLink(link) {
      window.open(link, '_blank');
    },
    async markAsReadUser(item) {
      const response = await BlendedCareRepository.markStudentAsRead({
        id: item.id,
      });
      return response;
    },
    async redirectDetail(item) {
      const routeData = this.$router.resolve({
        name: 'StudentDetailBlended',
        params: {
          id: item.id,
        },
        query: {
          typeCurriculum: TYPE_CURRICULUM_OBJ.ONLINE,
          log: true,
          taskType: 1,
          schoolLevel: this.$route.query.schoolLevel,
        },
      });
      window.open(routeData.href, '_blank');
      if (item.is_new_call) {
        const response = await this.markAsReadUser(item);
        if (response.message === 'Success') {
          // eslint-disable-next-line no-param-reassign
          item.is_new_call = 0;
        }
      }
    },
    createTask(item) {
      Bus.$emit('openModalTriggerTask', null, item);
    },
    async getContactPhoneRelated(contactId) {
      const res = await this.getCareContactDetail(contactId);
      if (res) {
        this.contactPhoneRelated = res.phoneRelated;
      }
    },
    async checkPhoneRelated(item) {
      await this.getContactPhoneRelated(item.contact_id);
      if (!this.contactPhoneRelated.length) {
        this.handleExecuteCall(item, item.mobile);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-data-table--fixed-header > .v-data-table__wrapper > table > thead > tr:nth-child(2) > th {
  top: 30px !important;
}
.student-high-care {
    width: 100%;
  .student-care-table {
    border-collapse: collapse;
    border-spacing: 0;
    .border-x {
      border-right: 2px solid #fff;
      border-left: 2px solid #fff;
    }
    .border-t {
      border-top: 2px solid #fff;
    }
    th {
      background: #f4f2f2 !important;
      text-align: left;
      padding: 0px 8px !important;
      color: #333;
      text-align: center;
      font-family: Roboto;
      font-size: 13px !important;
      line-height: 16px !important;
      font-style: normal;
      font-weight: 500;
      height: 30px;
      border-bottom: 1px solid #EFEEEE;
      text-wrap: nowrap;
      &.scroll-left {
        z-index: 4;
      }
    }
    td {
      padding: 0px 8px !important;
      color: #333;
      text-align: center;
      font-family: Roboto;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      border-bottom: 1px solid #EFEEEE;
      background: #fff;
      &.scroll-left {
        position: sticky;
        z-index: 1;
      }
    }
    tr {
      &.over-care-date {
        td {
          background: #FFEAEA !important;
        }
      }
    }
    tr:hover {
      td {
        background: #F8F8F8 !important;
      }
    }
    td.scroll-left {
      background: #fff;
    }
  }
  .list-status-history {
    border: 1px solid;
    margin-right: 5px;
    height: 25px;
    border-radius: 4px;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 13px;
    text-align: center;
    padding: 5px 5px 0 5px;
    text-wrap: nowrap;
  }
}
 .child-content {
    color: #FFF;
    font-size: 11px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-left: 25px;
  }
</style>
<style lang="scss">
.student-care-table {
  .v-data-table__wrapper {
    max-height: 700px !important;
  }
}
</style>
